import styled from 'styled-components';

export const StoreStateTreatmentWrapper = styled.div`
  overflow: ${({ allowOverflow }) => (allowOverflow ? 'initial' : 'hidden')};
  display: flex;
  flex-direction: column;
`;
